// src/i18n.ts
import { createI18n } from 'vue-i18n'

// Çeviri dosyalarını içe aktar
import enTranslationsFromFile from './locales/en.json'
import trTranslationsFromFile from './locales/tr.json'

// Web sitesi içeriği için MessageSchema tanımı
export interface MessageSchema {
  nav: {
    home: string
    about: string
    features: string
    solutions: string
    contact: string
    getStarted: string
  }
  hero: {
    title: string
    subtitle: string
    ctaButton: string
    slide1_title: string
    slide1_desc: string
    slide2_title: string
    slide2_desc: string
  }
  abilities: {
    title: string
    cloudComputing: {
      title: string
      description: string
    }
    machineLearning: {
      title: string
      description: string
    }
    scalableArchitecture: {
      title: string
      description: string
    }
  }
  solutions: {
    title: string
    interpretingData: {
      title: string
      description: string
    }
    modelTraining: {
      title: string
      description: string
    }
    dynamicAdaptation: {
      title: string
      description: string
    }
  }
  torukMagic: {
    title: string
    description: string
    deepTech: string
  }
solutionFocused: {
    title: string
    step1: string
    step2: string
    step3: string
    step4: string
    step5: string
    step1_desc?: string // Optional descriptions for steps
    step2_desc?: string
    step3_desc?: string
    step4_desc?: string
    step5_desc?: string
  }
  brandValue: {
    title: string
    Growth: {
      title: string
      description: string
    }
    Adoptation: {
      title: string
      description: string
    }
  }
  targetedIndustries: {
    title: string
    eCommerce: string
    mentalPhysicalHealth: string
    ticketing: string
    onlineTraining: string
    interiorDesign: string
    industrialEnterprises: string
  }
  aboutUsPage: {
    title: string
    mainGoal: string
    ourVision: string
    ourMission: string
    ourMissionDescription: string
    solutionFocused: {
      title: string
      interpretingData: string
      streamliningBusiness: string
      modelTraining: string
      dynamicAdaptation: string
      performanceManagement: string
    }
    magicFeaturesDetailed: {
      title: string
      logicAndData: string
      modelTrainingAndAdaptation: string
    }
    companyTimeline: {
      title: string
      subtitle: string
      items: {
        [year: string]: {
          title: string
          description: string
          achievements: {
            [key: string]: string
          }
        }
      }
      future: {
        title: string
        description: string
      }
    }
  }
  partners: {
    // New section
    title: string
  }
  contactPage: {
    // New section
    title: string
    intro: string
    formTitle: string
    nameLabel: string
    emailLabel: string
    messageLabel: string
    namePlaceholder: string
    emailPlaceholder: string
    messagePlaceholder: string
    submitButton: string
    successMessage: string
    errorMessage: string
    contactInfoTitle: string
    contactUs: string
  }
  footer: {
    copyright: string
    magicSaaS: string
    allRightsReserved: string
    navigation: string
    contactUs: string
    address: string
    phone: string
    email?: string
  }
  common: {
    learnMore: string
    contactSales: string
    readMore: string
  }
}

const messages: { en: MessageSchema; tr: MessageSchema } = {
  en: enTranslationsFromFile as MessageSchema,
  tr: trTranslationsFromFile as MessageSchema,
}

const i18n = createI18n<[MessageSchema], 'en' | 'tr'>({
  legacy: false,
  locale: localStorage.getItem('lang') || 'tr',
  fallbackLocale: 'en',
  messages: messages,
  globalInjection: true,
})

export default i18n
